module.exports = __webpack_public_path__ + "img/qrCode-bg.c16f319b.png";